import { get, post } from 'api/client';
import DateUtils from 'app/utils/date';
import dayjs from 'dayjs';
import config from 'config';
import { PagesProjects } from 'types/Page';

type CreateParams = {
  profileIds: number[];
  startDate: Date;
  endDate: Date;
  name: string;
};

type CreateResponse = {
  page_id: number;
  project_id: number;
}[];

const ContentPlanApi = {
  create(params: CreateParams): Promise<CreateResponse> {
    const data = new FormData();

    data.append('pageIds', JSON.stringify(params.profileIds));
    data.append('name', params.name);
    data.append('dateFrom', DateUtils.toDateString(dayjs(params.startDate)));
    data.append('dateTo', DateUtils.toDateString(dayjs(params.endDate)));

    return post('projects/ajaxCreateContentPlans', data);
  },
  getPagesContentPlans(pageIds: number[]): Promise<ApiResponse<PagesProjects>> {
    return get('projects', {
      baseURL: config.API_SERVICE_ENDPOINT,
      params: {
        pageIds: pageIds.join(','),
      },
    });
  },
};

export default ContentPlanApi;
